import { mapState, mapGetters, mapActions } from "vuex";

export const localize = {
  data: function () {
    return {
      gCollectingItem: -1
    }
  },

  methods: {
    ...mapActions([
      "initAUID"
    ]),
    localize(str) {
      if (!this.localizedUIReady) {
        return null;
      }
      let tag = str.toLowerCase().replace(/(\s|-)/g, "_");
      let obj = _.find(this.localizedUI, { tag });
      if (obj) {
        return obj.title;
      }
      return str;
      // return null;
    },

    //Manage products collections
    createCollection(collection_name)
    {        
        alert("collection_name="+collection_name);//check if name exists
    },
    addProductToCollection(pro_id)
    {
        this.initAUID();//INIT THE AUID BEFOR CALLING THE API
        alert("adding item:"+pro_id +" auid:"+this.auid);

    },
    getProductsCollection() 
    {
        //alert("adding item:"+pro_id);
    },
    shareProductsCollection() 
    {
        //alert("adding item:"+pro_id);
    }

  },
  computed: {
    ...mapState(["localizedUI", "localizedUIReady","auid"])
  }
};
